module.exports = __webpack_public_path__ + "img/upwork-review-large-1.232d42ab.jpg";